import React from 'react'
import { Routes, Route } from 'react-router-dom'
import MainLayout from '../pages/Layout/MainLayout'

import Inactive from '../pages/Auth/Inactive'

import Login from '../pages/Auth/Login'
import Home from '../pages/Home/Home'
// import SubCategory from '../pages/SubCategory/SubCategory'
import Products from '../pages/Products/Products'
import ProductDetail from '../pages/Products/ProductDetail'
import Carts from '../pages/Carts'

import Orders from '../pages/Orders'


const AppRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<Inactive />} />
      <Route path="/:client_code" element={<Login />} />
      <Route path="/inactive" element={<Inactive />} />
      <Route path="/app/:client_code" element={<MainLayout />}>
        <Route index element={<Home />} />
        <Route path="products/" element={<Products />} />
        <Route path="products/productdetails" element={<ProductDetail />} />
        {/* <Route path="subcategory" element={<SubCategory />} /> */}
        <Route path="subcategory/products" element={<Products />} />
        <Route path="subcategory/products/productdetails" element={<ProductDetail />} />
        <Route path="carts" element={<Carts />} />
        <Route path="orderhistory" element={<Orders />} />
      </Route>
    </Routes>
  )
}

export default AppRouter